import {
  isDniFeatureEnabled,
  isDniRegisteredFeatureEnabled
} from '@/config/featureFlags';
import { DEFAULT_INTERNAL_COLLECT_ALIAS } from '@/constants';
import type { Address } from '@/Domain/entities/Address';
import type { Cart } from '@/modules/cart/domain/Cart';
import type { Customer } from '@/modules/customer/domain/Customer';

type Entity = Address | Omit<Address, 'id'>;

export const getCollectShippingAddress = (
  cart: Cart,
  customer: Customer | null
): Entity => {
  const isRegistered = customer !== null;
  const isDniEnabled = isRegistered
    ? isDniRegisteredFeatureEnabled()
    : isDniFeatureEnabled();
  const firstName =
    cart?.shippingAddress?.firstName ?? customer?.firstName ?? '';
  const lastName = cart?.shippingAddress?.lastName ?? customer?.lastName ?? '';
  const phone = cart?.shippingAddress?.phone ?? customer?.phone ?? '';
  const customerRut = cart?.shippingAddress?.customerRut ?? customer?.rut ?? '';
  const email = cart?.shippingAddress?.email ?? customer?.email ?? '';

  const phoneWithoutSpaces = phone.replace(/\s/g, '');

  const result = {
    alias: DEFAULT_INTERNAL_COLLECT_ALIAS,
    region: cart?.shippingAddress?.region ?? 0,
    commune: cart?.shippingAddress?.commune ?? '',
    firstName: firstName,
    lastName: lastName,
    customerRut: customerRut,
    email: email,
    phone: phoneWithoutSpaces
  };

  if (isDniEnabled) {
    return {
      ...result,
      documentType: cart?.shippingAddress?.documentType ?? undefined,
      documentID: cart?.shippingAddress?.documentID ?? ''
    };
  }

  return result;
};

export default getCollectShippingAddress;
